'use client'

import { useEffect, useState } from 'react'

import { useFavoriteStore } from '@lib/store/useFavoriteStore'
import { HeartFavoriteIcon, HeartIcon } from '@modules/common/icons'

import LoginRequiredModal from './LoginRequiredModal'

interface FavoriteButtonProps {
  className?: string
  documentId?: string
  medusaId?: string
  documentType?: string
}

const FavoriteButton = ({
  className = 'flex w-fit rounded-full border-2 border-white p-1',
  documentId,
  medusaId,
  documentType,
  authenticated,
  clickable = false,
}: FavoriteButtonProps) => {
  const [showLoginModal, setShowLoginModal] = useState(false)

  const { favorites, addToFavorites, removeFromFavorites } = useFavoriteStore()

  const addOrRemoveFavorites = async (e) => {
    if (!clickable) return

    // Vérifier si l'utilisateur est authentifié
    if (!authenticated) {
      setShowLoginModal(true)
      return
    }
    if (
      favorites.find(
        (fav) => fav.id === documentId && fav.type === documentType
      )
    ) {
      removeFromFavorites(documentId, medusaId, documentType)
    } else {
      addToFavorites(documentId, medusaId, documentType)
    }

    return true
  }

  return (
    <>
      <button className={className} onClick={addOrRemoveFavorites} aria-label="Add to favorites">
        {favorites.map((fav) => fav.id).includes(documentId) ? (
          <HeartFavoriteIcon color="pink" width={40} height={40} />
        ) : (
          <HeartFavoriteIcon color="" width={40} height={40} />
        )}
      </button>

      <LoginRequiredModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />
    </>
  )
}

export default FavoriteButton
